// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2pJEQ","boxTitle":"Qualiphy_boxTitle__11_-A","box":"Qualiphy_box__2aGMa","toggleWrap":"Qualiphy_toggleWrap__3qqec"};